<div class="sidebar-sections" *ngFor="let section of sections; let isLast = last">
  <div class="section-items">
    @for (item of section.items; track item.uri || item.url || item.title || $index) {
      <a
        class="sidebar-item"
        [routerLink]="item.isBackButton ? null : item.url || item.uri"
        [routerLinkActive]="'active'"
        [class.active]="item.isActive"
        (click)="onItemClick($event, item)"
        tabindex="0"
        role="button"
      >
        @if (!item.isBackButton) {
          <div class="item-content">
            <ptl-icon *ngIf="item.icon" [size]="'m'" [icon]="item.icon"></ptl-icon>
            <span class="item-title body-m">{{ item.title }}</span>
          </div>
        } @else {
          <div class="back-button">
            <ptl-icon *ngIf="item.icon" [size]="'m'" [icon]="ArrowLeft01Icon"></ptl-icon>
            <div class="button-title body-m">{{ 'translations.global.button.back' | transloco }}</div>
          </div>
        }
      </a>
    }
  </div>

  <div class="section-separator" *ngIf="section.showSeparator && !isLast"></div>
</div>
